import { change } from '../slicers/selectedStepSlicer'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Get_employee from '../apiCalls/employee_call.js';
import './steps.css'

const StepFour = () => {
  const dispatch = useDispatch()
  const [step_input, setstep_input] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const callKey = useSelector((state) => state.keySlicer.value)
  const addedJob = useSelector((state) => state.addedJob.arr)
  const stepTwo = useSelector((state) => state.stepTwo.arr)
  const employeeSlicer = useSelector((state) => state.employeeSlicer.arr)
  const [isSaving, setIsSaving] = useState(false); // добавил новый стейт для задержки 1с
  const stepOneData = useSelector((state) => state.stepOne.arr); 
  const stepThreeData = useSelector((state) => state.stepTwo.arr);
  Get_employee()
  
  // function JobItem() {
  //   if (!step_input || step_input <= 0) {
  //     alert('Введите количество больше нуля');
  //     return;
  //   }
    
  //   setIsLoading(true);
    
  //   const today = new Date();
  //   const formattedDate = today.getFullYear() + '-' + 
  //     String(today.getMonth() + 1).padStart(2, '0') + '-' + 
  //     String(today.getDate()).padStart(2, '0');
    
  //   const body = [{
  //     "date": formattedDate,
  //     "Volume": Number(step_input),
  //     "sum": 0,
  //     "machineId": addedJob.realMachineId || addedJob.machineId,
  //     "workOrderId": addedJob.workOrderId,
  //     "employeeId": employeeSlicer.id,
  //     "operationTypeId": addedJob.operationTypeId
  //   }];
    
  //   let xhr = new XMLHttpRequest();
  //   let url = new URL(`${process.env.REACT_APP_BASEURL}completed-machine-operation`);
  //   xhr.open('POST', url);
  //   xhr.setRequestHeader('authtoken', callKey);
  //   xhr.setRequestHeader('Content-Type', 'application/json');
  //   xhr.responseType = 'json';
  //   xhr.send(JSON.stringify(body));
    
  //   xhr.onload = () => {
  //     setIsLoading(false);
  //     if (xhr.status === 200 || xhr.status === 201) {
  //       alert(`✅ Операция успешно сохранена!\nОбъём: ${step_input} ${stepTwo?.machineOperationType?.unitOfmeasurement?.nameCount || 'шт'}`);
  //       dispatch(change(0));
  //     } else {
  //       alert('❌ Ошибка при сохранении операции');
  //     }
  //   };
    
  //   xhr.onerror = () => {
  //     setIsLoading(false);
  //     alert('❌ Ошибка соединения с сервером');
  //   };
  // }
  
  function JobItem() {
    // БЛОКИРОВКА ПОВТОРНОГО НАЖАТИЯ
    if (!step_input || step_input <= 0) {
        alert('Введите количество больше нуля');
        return;
    }
    
    if (isSaving) {
        console.warn('⚠️ Операция уже отправляется, ожидайте...');
        return;
    }

    setIsSaving(true);

    const body = [{
        "date": new Date(new Date().toLocaleString('en-US', {timeZone: 'Asia/Yekaterinburg'})),
        "Volume": Number(step_input),
        "sum": 0,
        "machineId": addedJob.realMachineId || addedJob.machineId,
        "workOrderId": addedJob.workOrderId,
        "employeeId": employeeSlicer.id,
        "operationTypeId": addedJob.operationTypeId
    }];

    console.log('📤 Отправка операции:', body);

    let xhr = new XMLHttpRequest();
    let url = new URL(`${process.env.REACT_APP_BASEURL}completed-machine-operation`);
    xhr.open('POST', url);
    xhr.setRequestHeader('authtoken', callKey);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.responseType = 'json';
    xhr.send(JSON.stringify(body));

    xhr.onload = () => {
      //Аристов проверка id можно удаллить 
      // console.log('📦 ОТВЕТ ОТ POST /completed-machine-operation:', xhr.response);
      // console.log('🔑 Id созданной операции:', xhr.response?.[0]?.id);
      //Аристов проверка id можно удаллить 
      if (xhr.status === 200 || xhr.status === 201) {
          console.log('✅ Операция сохранена на сервере');
          
          // ЗАЩИТА ОТ ДУБЛЕЙ: Даем серверу 1 секунду, чтобы точно всё сохранить в базу
          setTimeout(() => {
              // Запрашиваем свежие данные
              let xhr2 = new XMLHttpRequest();
              let url2 = new URL(`${process.env.REACT_APP_BASEURL}employee/info`);
              xhr2.open('GET', url2, true);
              xhr2.setRequestHeader('authtoken', callKey);
              xhr2.setRequestHeader('Content-Type', 'application/json');
              xhr2.responseType = 'json';
              xhr2.send();

              xhr2.onload = () => {
                  setIsSaving(false); // РАЗБЛОКИРУЕМ КНОПКУ ТОЛЬКО ПОСЛЕ ОБНОВЛЕНИЯ
                  if (xhr2.status === 200) {
                      console.log('📥 Данные сотрудника обновлены');
                      dispatch({ type: 'employeeSlicer/add', payload: xhr2.response });
                  }
                  alert(`✅ Операция сохранена! Объём: ${step_input}`);
                  dispatch(change(0));
              };

              xhr2.onerror = () => {
                  setIsSaving(false);
                  alert('⚠️ Операция сохранена, но данные не обновились. Перезайдите в приложение.');
                  dispatch(change(0));
              };
          }, 5000); // Задержка 1000 мс (1 секунда)

      } else {
          setIsSaving(false);
          alert('❌ Ошибка при сохранении');
      }
  };

    xhr.onerror = () => {
        setIsSaving(false);
        alert('❌ Ошибка соединения с сервером');
    };
  }

  return (
    <div className="step-container">
      {/* Верхняя панель */}
      <div className="step-header">
        <button className="back-button" onClick={() => dispatch(change(3))}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="#265c9d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Назад</span>
        </button>
        <div className="step-indicator">
          <span className="step-dot completed"></span>
          <span className="step-dot completed"></span>
          <span className="step-dot completed"></span>
          <span className="step-dot active"></span>
        </div>
      </div>
      
      {/* Заголовок */}
      <div className="step-title-section">
        <h1 className="step-title">Ввод результата</h1>
        <p className="step-subtitle">
          Укажите объём выполненной работы
        </p>
      </div>
      
      {/* Поле ввода */}
      <div className="result-section">
        <div className="result-input-wrapper">
          <input
            className="result-input"
            type="number"
            placeholder="0"
            value={step_input}
            onChange={(e) => setstep_input(e.target.value)}
            autoFocus
          />
          <span className="result-unit">
            {stepTwo?.machineOperationType?.unitOfmeasurement?.nameCount || 'шт'}
          </span>
        </div>
      </div>
      
      {/* Сводка */}
      <div className="summary-card">
        <div className="summary-row">
            <span className="summary-label">Станок</span>
            <span className="summary-value">{stepOneData?.name || addedJob?.machineId || '—'}</span>
        </div>
        <div className="summary-row">
            <span className="summary-label">Операция</span>
            <span className="summary-value">{stepTwo?.machineOperationType?.name || '—'}</span>
        </div>
        <div className="summary-divider"></div>
        <div className="summary-row">
            <span className="summary-label">Дата операции</span>
            <span className="summary-value">{new Date().toLocaleDateString('ru-RU', {timeZone: 'Asia/Yekaterinburg'})}</span>
        </div>
        <div className="summary-row">
            <span className="summary-label">ЗПР №</span>
            <span className="summary-value">{addedJob?.workOrderName || '—'}</span>
        </div>
        <div className="summary-row">
            <span className="summary-label">Дата</span>
            <span className="summary-value">
              {addedJob?.workOrderDate 
                  ? new Date(addedJob.workOrderDate).toLocaleDateString('ru-RU') 
                  : '—'}
            </span>
        </div>
      </div>
      
      {/* Кнопка Сохранить */}
      <button 
        className="save-button"
        onClick={JobItem}
        //disabled={!step_input || isLoading}
        disabled={!step_input || isSaving}
      >
        {isLoading ? (
          <span className="button-spinner"></span>
        ) : (
          <>
            <span>Сохранить операцию</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M16 5L8 13L4 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </>
        )}
      </button>
    </div>
  );
};

export default StepFour;